export { packageStateKey } from '../state';
export { default as reducer } from '../reducers/reducer';
export { default as component } from './peopleHub';
